import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import Control from './Control';
import Option from './Option';
import ValueContainer from './ValueContainer';
import DropdownIndicator from './DropdownIndicator';
import { useTheme } from '../../contexts/Theme.context';
import customStyles from './styles/Styles';

type OptionType = { [string: string]: any };
type OptionsType = Array<OptionType>;

interface Options {
  dropdownOptions: OptionsType;
  className?: string;
  dropdownLabel?: string;
  dropdownOptionsCategory?: string;
  updateData: (data: any) => void;
  clearFilters?: boolean;
  setCleared?: (cleared: boolean) => void;
  placeholder?: string;
  selected?: string;
  isMulti?: boolean;
  preselectedValue?: string[] | null;
}

const Dropdown = ({
  dropdownOptions,
  dropdownLabel = '',
  dropdownOptionsCategory,
  className,
  updateData,
  clearFilters,
  setCleared,
  placeholder,
  selected = '',
  isMulti = true,
  preselectedValue = null,
}: Options) => {
  interface GroupedOption {
    label: string;
    options: OptionType[];
  }

  const groupedOptions: GroupedOption[] = [
    {
      label: dropdownOptionsCategory || '',
      options: dropdownOptions,
    },
  ];

  const options = dropdownOptionsCategory ? groupedOptions : dropdownOptions;

  const [value, setValue] = useState(null);

  const handleChange = (data: any) => {
    setValue(data);
    updateData(data);
  };

  useEffect(() => {
    if (!value && preselectedValue?.length) {
      const preselected = dropdownOptions.filter((i) => preselectedValue?.includes(i.value));

      handleChange(preselected);
    }
  }, [preselectedValue]);

  useEffect(() => {
    if (clearFilters) {
      setValue(null);

      if (setCleared) {
        setCleared(false);
      }

      updateData([]);
    }
  }, [clearFilters]);

  const { themeType } = useTheme();
  const borderColor = themeType === 'enTheme' ? '#0B75FD!important' : '#C6420A!important';

  return (
    <Select
      instanceId={dropdownLabel || dropdownOptionsCategory || 'dropdown'}
      value={value}
      className={className}
      options={options}
      isMulti={isMulti}
      isClearable={false}
      isSearchable={false}
      closeMenuOnSelect={false}
      closeMenuOnScroll={false}
      blurInputOnSelect={false}
      placeholder={placeholder}
      selected={selected}
      hideSelectedOptions={false}
      styles={customStyles(borderColor)}
      dropdownLabel={dropdownLabel}
      onChange={handleChange}
      components={{
        IndicatorSeparator: () => null,
        ValueContainer,
        DropdownIndicator,
        Control,
        Option,
      }}
    />
  );
};

export default Dropdown;
